import { render, staticRenderFns } from "./ProjectClusters.vue?vue&type=template&id=1d625dfc&scoped=true&"
import script from "./ProjectClusters.vue?vue&type=script&lang=js&"
export * from "./ProjectClusters.vue?vue&type=script&lang=js&"
import style0 from "./ProjectClusters.vue?vue&type=style&index=0&id=1d625dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d625dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d625dfc')) {
      api.createRecord('1d625dfc', component.options)
    } else {
      api.reload('1d625dfc', component.options)
    }
    module.hot.accept("./ProjectClusters.vue?vue&type=template&id=1d625dfc&scoped=true&", function () {
      api.rerender('1d625dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Projects/ProjectClusters.vue"
export default component.exports